/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConvertOptionsComponent } from './convert-options.component';
import { SysqueFrameModule } from '../../../../../../../shared/ui/src/lib/components/sysque-frame';
import { RouterModule, Routes } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular';
import { MatRadioModule } from '@angular/material/radio';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [
  {
    path: 'dialog/place-coupling-dialog',
    component: ConvertOptionsComponent,
    data: { componentTitle: 'Place Couplings' },
  },
  {
    path: 'dialog/convert-system-dialog',
    component: ConvertOptionsComponent,
    data: { componentTitle: 'Convert System' },
  },
];

@NgModule({
  declarations: [ConvertOptionsComponent],
  imports: [
    CommonModule,
    DxButtonModule,
    SysqueFrameModule,
    AlertModule,
    MatRadioModule,
    RouterModule.forChild(routes),
  ],
  exports: [ConvertOptionsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConvertOptionsModule {}
